<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="mx-2 elevation-0"
        color="secondary"
        fab
        v-bind="attrs"
        @click="openAppDownload"
        v-on="on"
        ><v-icon large>mdi-calendar-plus</v-icon></v-btn
      >
    </template>
    <span>Add to my calendar</span>
  </v-tooltip>
</template>

<script>
/* eslint-disable camelcase */
export default {
  name: 'AddToCalendar',
  props: {
    toolTip: { type: String, default: 'Add to calendar' },
    details: { type: String, default: '' },
    endTime: { type: Date, required: true },
    location: { type: String, default: '' },
    startTime: { type: Date, required: true },
    title: { type: String, required: true },
  },

  data() {
    return {
      googleCalendarLink: null,
    }
  },

  methods: {
    openAppDownload() {
      this.$emit('change')
    },
    addToCalendar() {
      this.googleCalendarLink = `http://calendar.google.com/calendar/r/eventedit?text=${
        this.title || ''
      }&dates=${this.formatDate(this.startTime)}/${this.formatDate(
        this.endTime
      )}&details=${this.details || ''}&location=${this.location || ''}`
      window.open(this.googleCalendarLink, '_blank')
    },

    formatDate(date) {
      const day = date.getDate()
      const monthIndex = date.getMonth()
      const year = date.getFullYear()

      const hour = date.getHours()
      const minutes = date.getMinutes()

      let formatted_date
      if (hour === 0 && minutes === 0) {
        formatted_date =
          '' + year + this.zero_pad2(monthIndex + 1) + this.zero_pad2(day)
      } else {
        formatted_date =
          '' +
          year +
          this.zero_pad2(monthIndex + 1) +
          this.zero_pad2(day) +
          'T' +
          this.zero_pad2(hour) +
          this.zero_pad2(minutes) +
          '00Z'
      }

      return formatted_date
    },

    zero_pad2(num) {
      if (num < 10) return '0' + num
      return num
    },
  },
}
</script>
